<!-- 随机验证码 -->
<template>
  <div class="s-canvas" @click="onClick">
    <canvas id="s-canvas" :width="$store.state.isMB?108:contentWidth" :height="contentHeight"></canvas>
  </div>
</template>
<script>
export default {
  name: "sIdentify",
  props: {
    identifyCode: {
      type: String,
      default: "1234",
    },
    fontSizeMin: {
      type: Number,
      default: 30,
    },
    fontSizeMax: {
      type: Number,
      default: 40,
    },
    backgroundColorMin: {
      type: Number,
      default: 180,
    },
    backgroundColorMax: {
      type: Number,
      default: 240,
    },
    colorMin: {
      type: Number,
      default: 50,
    },
    colorMax: {
      type: Number,
      default: 160,
    },
    lineColorMin: {
      type: Number,
      default: 40,
    },
    lineColorMax: {
      type: Number,
      default: 180,
    },
    dotColorMin: {
      type: Number,
      default: 0,
    },
    dotColorMax: {
      type: Number,
      default: 255,
    },
    contentWidth: {
      type: Number,
      default: 122,
    },
    contentHeight: {
      type: Number,
      default: 50,
    },
  },
  methods: {
    onClick() {
      // console.log("onClick");
      this.$emit("refresh");
    },
    // 生成一个随机数
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    // 生成一个随机的颜色
    randomColor(min, max) {
      let r = this.randomNum(min, max);
      let g = this.randomNum(min, max);
      let b = this.randomNum(min, max);
      return "rgb(" + r + "," + g + "," + b + ")";
    },
    drawPic() {
      let canvas = document.getElementById("s-canvas");
      let ctx = canvas.getContext("2d");
      ctx.textBaseline = "bottom";

      // 绘制渐变背景
      const gradient = ctx.createLinearGradient(0, 0, this.contentWidth, this.contentHeight);
      gradient.addColorStop(0, this.randomColor(100, 150));
      gradient.addColorStop(0.5, this.randomColor(150, 200));
      gradient.addColorStop(1, this.randomColor(200, 250));
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, this.contentWidth, this.contentHeight);

      // 绘制网格干扰
      this.drawGrid(ctx);

      // 绘制霓虹文字
      for (let i = 0; i < this.identifyCode.length; i++) {
        this.drawNeonText(ctx, this.identifyCode[i], i);
      }

      this.drawLine2(ctx);
    },
    drawText(ctx, txt, i) {
      ctx.fillStyle = this.randomColor(this.colorMin, this.colorMax);
      ctx.font =
        this.randomNum(this.fontSizeMin, this.fontSizeMax) + "px SimHei";
      let x = (i + 1) * ((this.contentWidth - 5) / (this.identifyCode.length + 1));
      let y = this.randomNum(this.fontSizeMax, this.contentHeight - 5);
      var deg = this.randomNum(-10, 10);
      // 修改坐标原点和旋转角度
      ctx.translate(x, y);
      ctx.rotate((deg * Math.PI) / 180);
      ctx.fillText(txt, 0, 0);
      // 恢复坐标原点和旋转角度
      ctx.rotate((-deg * Math.PI) / 180);
      ctx.translate(-x, -y);
    },
    // 霓虹文字
    drawNeonText(ctx, txt, i) {
      const neonColors = [
        "#f03764", // 鲜红
        "#2979ff", // 亮蓝
        "#f09110", // 橙黄
        "#10e676", // 鲜绿
        "#d520f0", // 鲜紫
        "#10bcd4", // 青色
        "#f06d10"  // 深橙
      ];
      const neonColor = neonColors[this.randomNum(0, neonColors.length - 1)];

      // 加粗字
      const fontSize = this.randomNum(this.fontSizeMin, this.fontSizeMax);
      ctx.font = `bold ${fontSize}px SimHei`;

      // 先绘制深色阴影
      ctx.fillStyle = "#1a1a1a";
      ctx.shadowColor = "rgba(0, 0, 0, 0.5)";
      ctx.shadowBlur = 4;
      ctx.shadowOffsetX = 2;
      ctx.shadowOffsetY = 2;

      let x = (i + 1) * ((this.contentWidth - 5) / (this.identifyCode.length + 1));
      let y = this.randomNum(this.fontSizeMax, this.contentHeight - 5);
      var deg = this.randomNum(-8, 8); // 减小旋转角度

      ctx.translate(x, y);
      ctx.rotate((deg * Math.PI) / 180);
      ctx.fillText(txt, 0, 0);
      ctx.rotate((-deg * Math.PI) / 180);
      ctx.translate(-x, -y);

      // 重置阴影
      ctx.shadowBlur = 0;
      ctx.shadowOffsetX = 0;
      ctx.shadowOffsetY = 0;
      ctx.fillStyle = neonColor;

      ctx.translate(x, y);
      ctx.rotate((deg * Math.PI) / 180);
      ctx.fillText(txt, 0, 0);
      ctx.rotate((-deg * Math.PI) / 180);
      ctx.translate(-x, -y);
    },
    // 绘制网格干扰
    drawGrid(ctx) {
      // 主网格线
      const gridSpacing = 12;
      ctx.strokeStyle = "rgba(255, 255, 255, 0.25)";
      ctx.lineWidth = 1;

      // 绘制竖线
      for (let x = 0; x <= this.contentWidth; x += gridSpacing) {
        ctx.beginPath();
        ctx.moveTo(x, 0);
        ctx.lineTo(x, this.contentHeight);
        ctx.stroke();
      }

      // 绘制横线
      for (let y = 0; y <= this.contentHeight; y += gridSpacing) {
        ctx.beginPath();
        ctx.moveTo(0, y);
        ctx.lineTo(this.contentWidth, y);
        ctx.stroke();
      }

      // 添加细网格线
      const fineGridSpacing = 4;
      ctx.strokeStyle = "rgba(255, 255, 255, 0.1)";
      ctx.lineWidth = 0.5;

      for (let x = 0; x <= this.contentWidth; x += fineGridSpacing) {
        ctx.beginPath();
        ctx.moveTo(x, 0);
        ctx.lineTo(x, this.contentHeight);
        ctx.stroke();
      }

      for (let y = 0; y <= this.contentHeight; y += fineGridSpacing) {
        ctx.beginPath();
        ctx.moveTo(0, y);
        ctx.lineTo(this.contentWidth, y);
        ctx.stroke();
      }

      // 随机粗线
      for (let i = 0; i < 5; i++) {
        ctx.strokeStyle = `rgba(255, 255, 255, ${this.randomNum(30, 70) / 100})`;
        ctx.lineWidth = this.randomNum(1, 5);
        ctx.beginPath();
        ctx.moveTo(
          this.randomNum(0, this.contentWidth),
          this.randomNum(0, this.contentHeight)
        );
        ctx.lineTo(
          this.randomNum(0, this.contentWidth),
          this.randomNum(0, this.contentHeight)
        );
        ctx.stroke();
      }

      // 添加对角线干扰
      for (let i = 0; i < 3; i++) {
        ctx.strokeStyle = `rgba(200, 220, 255, ${this.randomNum(20, 50) / 100})`;
        ctx.lineWidth = this.randomNum(1, 3);
        ctx.beginPath();
        const startX = this.randomNum(0, this.contentWidth);
        const startY = this.randomNum(0, this.contentHeight);
        ctx.moveTo(startX, startY);
        ctx.lineTo(startX + this.randomNum(-30, 30), startY + this.randomNum(-30, 30));
        ctx.stroke();
      }
    },
    drawLine(ctx) {
      // 绘制更多干扰线
      for (let i = 0; i < 8; i++) {
        ctx.strokeStyle = this.randomColor(
          this.lineColorMin,
          this.lineColorMax
        );
        ctx.lineWidth = this.randomNum(1, 3);
        ctx.beginPath();
        const startX = this.randomNum(0, this.contentWidth);
        const startY = this.randomNum(0, this.contentHeight);
        ctx.moveTo(startX, startY);
        ctx.lineTo(
          this.randomNum(0, this.contentWidth),
          this.randomNum(0, this.contentHeight)
        );
        ctx.stroke();
      }

      // 添加波浪形曲线干扰
      for (let i = 0; i < 3; i++) {
        ctx.strokeStyle = `rgba(${this.randomNum(100, 200)}, ${this.randomNum(100, 200)}, ${this.randomNum(150, 255)}, ${this.randomNum(40, 70) / 100})`;
        ctx.lineWidth = this.randomNum(1, 2);
        ctx.beginPath();
        const startX = this.randomNum(0, this.contentWidth / 2);
        const startY = this.randomNum(0, this.contentHeight);
        ctx.moveTo(startX, startY);
        ctx.bezierCurveTo(
          this.randomNum(0, this.contentWidth),
          this.randomNum(0, this.contentHeight),
          this.randomNum(0, this.contentWidth),
          this.randomNum(0, this.contentHeight),
          this.randomNum(this.contentWidth / 2, this.contentWidth),
          this.randomNum(0, this.contentHeight)
        );
        ctx.stroke();
      }

      // 添加虚线干扰
      ctx.setLineDash([this.randomNum(2, 5), this.randomNum(3, 8)]);
      for (let i = 0; i < 4; i++) {
        ctx.strokeStyle = `rgba(${this.randomNum(150, 255)}, ${this.randomNum(150, 255)}, ${this.randomNum(150, 255)}, ${this.randomNum(50, 80) / 100})`;
        ctx.lineWidth = this.randomNum(1, 2);
        ctx.beginPath();
        ctx.moveTo(
          this.randomNum(0, this.contentWidth),
          this.randomNum(0, this.contentHeight)
        );
        ctx.lineTo(
          this.randomNum(0, this.contentWidth),
          this.randomNum(0, this.contentHeight)
        );
        ctx.stroke();
      }
      ctx.setLineDash([]); // 重置虚线设置
    },
    drawLine2(ctx) {
      // 绘制更多干扰线
      for (let i = 0; i < 3; i++) {
        ctx.strokeStyle = this.randomColor(
          this.lineColorMin,
          this.lineColorMax
        );
        ctx.lineWidth = this.randomNum(1, 3);
        ctx.beginPath();
        const startX = this.randomNum(0, this.contentWidth);
        const startY = this.randomNum(0, this.contentHeight);
        ctx.moveTo(startX, startY);
        ctx.lineTo(
          this.randomNum(0, this.contentWidth),
          this.randomNum(0, this.contentHeight)
        );
        ctx.stroke();
      }

      // 添加波浪形曲线干扰
      for (let i = 0; i < 2; i++) {
        ctx.strokeStyle = `rgba(${this.randomNum(100, 200)}, ${this.randomNum(100, 200)}, ${this.randomNum(150, 255)}, ${this.randomNum(40, 70) / 100})`;
        ctx.lineWidth = this.randomNum(1, 2);
        ctx.beginPath();
        const startX = this.randomNum(0, this.contentWidth / 2);
        const startY = this.randomNum(0, this.contentHeight);
        ctx.moveTo(startX, startY);
        ctx.bezierCurveTo(
          this.randomNum(0, this.contentWidth),
          this.randomNum(0, this.contentHeight),
          this.randomNum(0, this.contentWidth),
          this.randomNum(0, this.contentHeight),
          this.randomNum(this.contentWidth / 2, this.contentWidth),
          this.randomNum(0, this.contentHeight)
        );
        ctx.stroke();
      }

      // 添加虚线干扰
      ctx.setLineDash([this.randomNum(2, 5), this.randomNum(3, 8)]);
      for (let i = 0; i < 2; i++) {
        ctx.strokeStyle = `rgba(${this.randomNum(150, 255)}, ${this.randomNum(150, 255)}, ${this.randomNum(150, 255)}, ${this.randomNum(50, 80) / 100})`;
        ctx.lineWidth = this.randomNum(1, 2);
        ctx.beginPath();
        ctx.moveTo(
          this.randomNum(0, this.contentWidth),
          this.randomNum(0, this.contentHeight)
        );
        ctx.lineTo(
          this.randomNum(0, this.contentWidth),
          this.randomNum(0, this.contentHeight)
        );
        ctx.stroke();
      }
      ctx.setLineDash([]); // 重置虚线设置
    },
    drawDot(ctx) {
      // 绘制干扰点
      for (let i = 0; i < 50; i++) {
        ctx.fillStyle = this.randomColor(0, 255);
        ctx.beginPath();
        ctx.arc(
          this.randomNum(0, this.contentWidth),
          this.randomNum(0, this.contentHeight),
          this.randomNum(2, 3),
          0,
          2 * Math.PI
        );
        ctx.fill();
      }
    },
  },
  watch: {
    identifyCode() {
      this.drawPic();
    },
  },
  mounted() {
    this.drawPic();
  },
};
</script>
<style lang="scss" scoped>
#s-canvas {
  margin-top: -0.3px;
  border-radius: 4px;
}
.s-canvas {
  height: 38px;
  canvas {
    margin-top: 1px;
    // margin-left: 8px;
  }
}
</style>